import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useStore, useSelector, useDispatch } from 'react-redux'
import { Box, Button, IconButton, Stack, Tooltip } from '@mui/material'
import { newGetList, newPost } from '../../helper/baseFetch'
import MultiLangLabel from '../../Component/common/label/MultiLangLabel'
import MUITable from '../../Component/common/table/MUITable'
import { ListFilter } from '../../Component/ListDisplay/ListFilter'
import Iconify from '../../Component/common/iconify/Iconify'
import { ICONIFY } from '../../Constants/iconify'
import { API_PATH } from '../../Constants/path'
import { Add } from '@mui/icons-material'
import SharedDialog from '../../Component/common/dialog/SharedDialog'
import SurveyPanel from '../../Component/Flow/survey/SurveyPanel'
import SurveyDialog from '../../Component/Flow/survey/SurveyDialog'
import { setSurveyFlow } from '../../actions/surveyFlowAction'
import { constants } from '../../Constants/constants'
import { KEYS_OF_DRAFT_DATA, KEYS_OF_HAVE_DRAFT, KEYS_OF_IS_CREATE, KEYS_OF_TEMP_DRAFT_DATA, PREFIX_OF_TEMP_NODE } from '../../Component/Flow/constant'
import StatusLabel from '../../Component/_v2/label/StatusChip'
import { getQuery, getQueryParamObject, getParamQueryString } from '../../helper/util'
import _ from 'lodash'
import { useListParam } from '../../hooks/useListParam'


// survey listing page
export default function SurveyList({
  newPath,
  editBtn = true,
  createBtn = true,
  cloneBtn = true,
  onClickListRow,
  readOnly = false
}) {
  const changeUrlQueryString = true
  const resource = 'surveyPage'
  const filterParams = getQuery()

  const SurveyListTitleList = [
        {
          key: constants.LIST_DISPLAY_TYPE.STRING,
          value: 'title',
          sort: true,
        },
        {
          key: constants.LIST_DISPLAY_TYPE.STRING,
          value: 'remarks',
          sort: false,
          minSize: true,
        },
        {
          key: constants.LIST_DISPLAY_TYPE.STRING,
          value: 'status',
          sort: true,
        },
      ]

  const listFilters = [
    {
      className: 'filter-input',
      label: { resource: resource, key: 'title' },
      clear: true,
      value: '',
      name: 'title',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'remarks' },
      clear: true,
      value: '',
      name: 'remarks',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'status' },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.BRAND.STATUS,
      name: 'status',
      size: constants.SIZE.SMALL,
    },
  ]

  const {
    param,
    setParam,
    onChangeParam,
    onChangeListFilters,
    onChangeListSort,
    onChangeListPage: onChangeListPageParam,
    onChangeListRowsPerPage: onChangeListRowsPerPageParam,
  } = useListParam({
    initialPath: newPath ? newPath : '',
    initialListFilters: _.cloneDeep(listFilters),
    listTitles: SurveyListTitleList,
    initialSort: 'updateTimestamp',
    initialDirection: 'DESC',
    initialPage: 0,
    initialRowsPerPage: 10,
    changeUrlQueryString,
  })

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 200,
      flex: 1,
    },
    {
      field: 'title',
      headerName: 'Title',
      width: 200,
      flex: 1,
      renderCell: (params) => <MultiLangLabel nameObj={params.row.title} direction='vertical' gap={0.5} itemWidth='100%' />,
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      width: 150,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 50,
      renderCell: (params) => <StatusLabel resource="survey" keyName={params.value} />
    },
    readOnly
      ? {}
      : {
        field: 'edit',
        headerName: '',
        width: 50,
        renderCell: (params) => editBtn ? (
          <Tooltip title='edit'>
            <IconButton onClick={() => onClickEdit(params.row.id)}>
              <Iconify icon={ICONIFY.edit} />
            </IconButton>
          </Tooltip>
        ) : null,
      },
    readOnly ? {} : {
        field: 'clone',
        headerName: '',
        width: 50,
        renderCell: (params) => cloneBtn ? (
          <Tooltip title='clone'>
            <IconButton onClick={() => onClickClone(params.row.id)}>
              <Iconify icon={ICONIFY.clone} />
            </IconButton>
          </Tooltip>
        ) : null
    }
  ]

  const store = useStore()
  const savedSurveyFlow = useSelector(state => state.surveyFlow.ui.surveyFlow)
  const savedSurveyCommonStatus = useSelector(state => state.surveyFlow.ui.common)
  const dispatch = useDispatch()

  const history = useHistory()

  const [list, setList] = useState([])
  const [listLength, setListLength] = useState(0)
  const [listPagination, setListPagination] = useState({
    sort: 'updateTimestamp',
    order: 'DESC',
    pageSize: 10,
    page: 0,
    filter: {},
  })
  const [showDialog, setShowDialog] = useState(false)
  const [isCreateMode, setIsCreateMode] = useState(false)
  const [haveDraft, setHaveDraft] = useState(false)

  const draftId = useRef(null)

  const handleDraftIgnore = () => setHaveDraft(false)
  const handleDraftView = () => history.push(`/${constants.PATH.SURVEY.BASE}/` + `${draftId.current}?${KEYS_OF_HAVE_DRAFT}=true`)

  const getList = () => {
    let tempParam = _.cloneDeep(param)
    const filter = {}
    tempParam.listFilters.forEach((filterItem) => {
      if (filterItem.value !== '' && filterItem.value !== undefined) {
        filter[filterItem.name] = filterItem.value
      }
    })

    const newListPagination = {
      ...listPagination,
      // filter: JSON.stringify(listPagination.filter),
      filter: JSON.stringify(filter),
      // API expects 1-based page index
      page: tempParam.page,
      perPage: tempParam.rowsPerPage

    }

    newGetList({
      path: API_PATH.survey.base,
      queryObj: newListPagination,
      successCallback: (payload) => setList(payload),
      store: store,
      getListLength: (listLength) => setListLength(listLength),
    })
  }

  const onClickCreate = () => {
    dispatch(setSurveyFlow(constants.SURVEY_FLOW))
    setIsCreateMode(true)
    setShowDialog(true)
  }

  const onClickEdit = (id) => {
    history.push(`/${constants.PATH.SURVEY.BASE}/` + id)
  }

  const onClickClone = (id) => {

    newPost({
      path: API_PATH.survey.clone,
      body: { sourceId: id },
      successCallback: (payload) => {
        getList()
      },
      store: store,
    })
  }

  const handleSubmit = (data) => {
    setIsCreateMode(false)
    dispatch(setSurveyFlow({ ...savedSurveyFlow, ...data }))
    history.push(`/${constants.PATH.SURVEY.BASE}/` + `${PREFIX_OF_TEMP_NODE}${Date.now()}?${KEYS_OF_IS_CREATE}=true`)
  }

  function onChangeListPage(e, newPage) {
    setListPagination((prev) => ({ ...prev, page: newPage }))
    onChangeListPageParam(newPage)
  }

  function onChangeListRowsPerPage(e) {
    const rowsPerPage = e?.target?.value
    setListPagination((prev) => ({ ...prev, pageSize: rowsPerPage }))
    onChangeListRowsPerPageParam(rowsPerPage)
  }

  // onChangeParam handled by useListParam

  // URL sync and param initialization handled by useListParam

  // handle draft dialog
  useEffect(() => {
    setHaveDraft(savedSurveyCommonStatus?.haveDraft)

    if (savedSurveyCommonStatus?.haveDraft) {
      const draftData = localStorage.getItem(KEYS_OF_DRAFT_DATA)

      if (draftData) {
        draftId.current = JSON.parse(draftData)?.id
        localStorage.setItem(KEYS_OF_TEMP_DRAFT_DATA, draftData)
      }
    }
  }, [savedSurveyCommonStatus?.haveDraft])

  useEffect(() => {
    getList()
  }, [param.count]) // eslint-disable-line react-hooks/exhaustive-deps

  // keep local pagination state (MUITable) in sync with param (from hook / URL)
  useEffect(() => {
    setListPagination((prev) => ({
      ...prev,
      page: param.page ?? 0,
      pageSize: param.rowsPerPage ?? prev.pageSize,
    }))
  }, [param.page, param.rowsPerPage])

  return (
    <>
      {/* <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}> */}
      <Box sx={{ p: 3 }}>
        {!onClickListRow && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="title">
              Survey
            </div>
            <Button startIcon={<Add />} variant='contained' onClick={onClickCreate}>
              Create
            </Button>
          </Box>
        )}

        <ListFilter onChangeListFilters={onChangeListFilters} listFilters={param.listFilters} />

        <Box sx={{ flex: 1, overflow: 'auto' }}>
          <MUITable
            columns={columns}
            rows={list}
            pagination={listPagination}
            setPagination={setListPagination}
            listLength={listLength}
            onClickListRow={onClickListRow}
            handleChangePage={onChangeListPage}
            handleChangeRowsPerPage={onChangeListRowsPerPage}
          />
        </Box>
      </Box>

      {/* create dialog */}
      <SurveyDialog
        isEdit={!isCreateMode}
        open={showDialog}
        toggleOpen={setShowDialog}
        handleSubmit={handleSubmit}
      />

      {/* draft dialog */}
      <SharedDialog
        maxWidth='sm'
        open={haveDraft}
        onClose={handleDraftIgnore}
        title='You have a unsave draft'
        actions={
          <Stack direction={'row'} gap={2}>
            <Button variant='outlined' onClick={handleDraftIgnore}>ignore</Button>
            <Button variant='contained' onClick={handleDraftView}>view</Button>
          </Stack>
        }
      />
    </>
  )
}
